/**
 * מניעת כפילות בקשות בזמן קצר (למשל React Strict Mode — mount כפול).
 * אותו מפתח מחזיר את אותה הבטחה עד להשלמה + חלון קצר.
 */
const slots = {
  flights: { promise: null, startedAt: 0 },
  packages: { promise: null, startedAt: 0 },
  organized: { promise: null, startedAt: 0 },
  homeFeed: { promise: null, startedAt: 0 },
  prefetchFull: { promise: null, startedAt: 0 },
};

function getSlot(key) {
  if (!slots[key]) {
    slots[key] = { promise: null, startedAt: 0 };
  }
  return slots[key];
}

const REUSE_MS = 1200;

function clearSlot(slot) {
  setTimeout(() => {
    slot.promise = null;
  }, 80);
}

/**
 * @param {string} key — מפתחות ידועים או לדוגמה dest_dest_rome
 * @param {() => Promise<any>} factory
 */
export function runDedupedDiscovery(key, factory) {
  const slot = getSlot(key);
  const now = Date.now();
  if (
    slot.promise &&
    now - slot.startedAt < REUSE_MS
  ) {
    return slot.promise;
  }
  slot.startedAt = now;
  slot.promise = factory()
    .then((v) => v)
    .finally(() => {
      clearSlot(slot);
    });
  return slot.promise;
}
